export enum ActionType {
	DEFINE_CLIENT_DATA = "client/DEFINE_CLIENT_DATA",
	UPDATE_DOCTOR = "client/UPDATE_DOCTOR",
	ADD_LEAD = "client/ADD_LEAD",
	UPDATE_LEAD = "client/UPDATE_LEAD",
	REPLACE_PHONE = "client/REPLACE_PHONE",
	DEFINE_AB_TEST_CASE = "client/DEFINE_AB_TEST_CASE",
	SET_PHONE_FORM_DATA = "client/SET_PHONE_FORM_DATA",
	ENABLE_WHATS_APP = "client/ENABLE_WHATS_APP",
	ENABLE_SPECIAL_OFFERS = "client/ENABLE_SPECIAL_OFFERS",
	UPDATE_SERVICE_LIST = "client/UPDATE_SERVICE_LIST",
	ENABLE_COMMON_SERVICE_LIST = "client/ENABLE_COMMON_SERVICE_LIST",
	ADD_TEST_VARIATIONS = "client/ADD_TEST_VARIATIONS",
	ADD_CUSTOM_CONTENT = "client/ADD_CUSTOM_CONTENT",
	UPDATE_CUSTOM_LEAD_PARAMS = "client/UPDATE_CUSTOM_LEAD_PARAMS",
	UPDATE_CALCULATOR = "client/UPDATE_CALCULATOR",
	SET_POLICY_AGREE_STATUS = "client/SET_POLICY_AGREE_STATUS"
}